import React from "react"
import * as styles from "./Styles/MainVisual.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

import title from "../../images/title_desktop.png"

import Filter from "./Filter"

const MV = (props) => {
  return (
    <React.Fragment>
      <div className={styles.container}>
        <div className={cn("row", "left")}>
          <img src={title} />
        </div>
        <div className={cn("row", "right")}>
          <Filter
            {...props}
            onSubmit={props.onSubmit}
            showLoader={props.showLoader}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default MV
